document.addEventListener('DOMContentLoaded', () => {
    const susanContainers = document.querySelectorAll('.item-window-susan');
    
    susanContainers.forEach(container => {
        const susanItemsContainer = container.querySelector('.susan-items-container');
        const scrollLeftBtn = container.querySelector('.susan-controls img:first-child');
        const scrollRightBtn = container.querySelector('.susan-controls img:last-child');
        
        const itemWidth = container.querySelector('.susan-item').offsetWidth;
        const scrollAmount = itemWidth + parseInt(getComputedStyle(container.querySelector('.susan-item')).marginRight);
        
        scrollLeftBtn.addEventListener('click', () => {
            susanItemsContainer.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        });
        
        scrollRightBtn.addEventListener('click', () => {
            susanItemsContainer.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        });
    });
});

